<script>
export default {
    name: "ConfirmBillInpatientModal",

    data() {

        return {
            invoice: {
              description: ``,
              ref: ``,
            },
        };
    },

    props: {
        dischargeDetails: Object,
        showModal: Boolean,
    },

    computed: {

        // invoiceDetails() {

        //     return {
        //       billDetails: this.postBills,
        //       ...this.invoice,
        //       patientID: this.$route.params.patientID,
        //       patientName:'',
        //       visitNo: this.$route.params.visitNO,
        //       txnDate: window.moment().format(`YYYY-MM-DD`),
        //       userName: this.$root.username,
        //       billAmount: this.billTotal,
        //     };
        // },

//         billTotal() {

// const billAmounts = this.postBills.map(bill => parseFloat(bill.grandTotal));

// if(!billAmounts.length) return 0;

// return billAmounts.reduce((amt, sum) => amt+sum);
// }, billswithNetzero() {

// const billAmounts = this.postBills.filter(bill=>bill.grandTotal==0).map(bill => parseFloat(bill.grandTotal));

// if(!billAmounts.length) return 0;

// return billAmounts.length;
// },
    },

    methods: {

        saveData() {
          this.$root.loading = true;
            this.$http.post(`InPatient/BillDischarge`, this.dischargeDetails).then(response => {
            this.$emit(`refresh`);
            this.$root.loading = false;
            this.$emit(`closeModal`);
            window.Swal.fire({ type: `success`, text: response.data });
          }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
            // this.$http.post(`InPatient/BillDischarge`, this.dischargeDetails).then(() => {
            //     this.$root.loading = false;
            //     window.Swal.fire({ text: response.data.msg, type: 'success', });
            //     this.$emit('closeModal');
            //     this.$emit('refresh');
            // }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Generate Inpatient Bill</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full text-center -m-3">
            <h5 class="font-medium text-base">Confirm Bill Inpatient.</h5> 
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
          class="btn-danger btn-sm text-xs mr-4" 
          @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Cancel</button>
        <button 
          class="btn-primary btn-sm text-xs" 
          @click.prevent="saveData">
            <i class="fa fa-save"></i> Bill In patient</button>
      </template>
    </tail-modal>
</template>
